export default __webpack_public_path__ + "static/media/Logo.4df281e5.svg";